module.exports = __webpack_public_path__ + "img/valuationResults.9de2e88b.png";